import { Country } from '../country';

export const countryValues = {
    COUNTRY: Country.ES,
    PREFERRED_COUNTRY: 9305,
    PUSH_APP_ID: 9200,
    MARKET_ANDROID_ID: 'com.riafinancial.customerapp',
    DEFAULT_LANG: 'en-US',
    AVAILABLE_LANGUAGES: ["es-ES", "es-CL", "en-US", "bn-BD", "ms-MY", "ne-NP", "pl-PL", "uk-UA", "fr-FR", "it-IT"],
    DEFAULT_LOCALE: 'es-ES',
    DISPLAY_LATIN_KEYBOARD: false,
    DISPLAY_EURONET_LOGO: false
}



// WEBPACK FOOTER //
// ./src/environment/countries/country.ts